import { Auth } from 'aws-amplify';

export function sendForgotPasswordCode ({email}) {
  return Auth.forgotPassword(email.toLowerCase());
}

export function resetPassword ({email, code, newPassword}) {
  return Auth.forgotPasswordSubmit(email.toLowerCase(), code, newPassword);
}
